import React, { forwardRef } from 'react';
import classnames from 'clsx';
import { Element } from '../element';
import * as styles from './button.styles';

/**
 *
 * @type {typeof import('.').Button}
 */
const Button = forwardRef(({ variant = 'primary', className, children, size, active, square, ...props }, ref) => {
  const child = React.Children.toArray(children);
  return (
    <Element
      ref={ref}
      as="button"
      type="button"
      className={classnames(
        styles.button,
        {
          [styles.variants[variant]]: variant,
          [styles.variants.active]: active,
          [styles.variants.square]: square,
          [styles.variants[size]]: size,
          [styles.variants.onlyChild]: child.length === 1,
        },
        className,
      )}
      {...props}
    >
      {child}
    </Element>
  );
});

if (process.env.NODE_ENV !== 'production') {
  Button.displayName = 'Button';
}

export default Button;
